<script lang="ts">
  // BJL-CHECK: Badge (used) — the installed Tag theme has no layout chrome; Badge is the
  // themed non-interactive BJL chip. MTA data supplies only its label and colors.
  import { Badge } from '@byjackli-labs/ui/Badge'
  import { getRouteColor } from '../ui/colors'

  interface Props {
    routeId: string
    label?: string
    size?: 'xs' | 'sm' | 'md'
  }

  const { routeId, label = routeId, size = 'sm' }: Props = $props()
</script>

<Badge {size} register="mono" colors={{ bg: getRouteColor(routeId), text: '#fff' }}>
  {label}
</Badge>
